import React from 'react';
import classnames from 'classnames';
import { node, func, bool } from 'prop-types';

const TabItem = ({
  children,
  active,
  onClick,
}) => (
  <a
    role="button"
    tabIndex="0"
    onClick={onClick}
    className={classnames(
      'mdc-tab',
      { 'mdc-tab--active': active },
    )}
  >
    {children}
    <span className="mdc-tab__indicator" />
  </a>
);

TabItem.propTypes = {
  active: bool.isRequired,
  children: node.isRequired,
  onClick: func.isRequired,
};

export default TabItem;
